import { useEffect, useState } from 'react';
import AdminLayout from '../layouts/AdminLayout';
import StartupAdOverlay from '../components/StartupAdOverlay';
import BannerAd from '../components/BannerAd';

// ─── Inline types (replaces @/lib/ads) ────────────
interface AdCreative {
  id: string;
  title: string;
  description: string;
  sponsor: string;
  ctaLabel: string;
  href?: string;
  imageUrl?: string;
  badge?: string;
  background?: string;
}

interface DashboardStats {
  pendingDispatch: string;
  activeWorkers: string;
  abnormalAttendance: string;
  completionRate: string;
}

export default function Dashboard() {
  const [adData, setAdData] = useState<AdCreative | null>(null);
  const [showAd, setShowAd] = useState(false);
  const [stats, setStats] = useState<DashboardStats | null>(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const mockStats: DashboardStats = {
          pendingDispatch: '42',
          activeWorkers: '128',
          abnormalAttendance: '3',
          completionRate: '94%',
        };

        const mockResponse: AdCreative = {
          id: 'dashboard-release-notice',
          title: '数字化零工调度新引擎',
          description: '早知 2.0 版本现已发布，增强了 AI 智能匹配算法与声纹活体检测。建议立即更新体验。',
          sponsor: '早知科技 (ZHAOZHI TECH)',
          ctaLabel: '立即体验',
          href: '/jobs',
          badge: '官方发布',
          background: 'linear-gradient(135deg, #6366f1, #a855f7)',
          imageUrl: 'https://images.unsplash.com/photo-1551434678-e076c223a692?q=80&w=2070&auto=format&fit=crop',
        };

        setTimeout(() => {
          setStats(mockStats);
          setAdData(mockResponse);
          setShowAd(true);
        }, 800);
      } catch (error) {
        console.error('接口连接失败:', error);
      }
    };

    fetchDashboardData();
  }, []);

  return (
    <AdminLayout>
      <section className="space-y-2">
        <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">数据概览</h1>
        <p className="text-slate-500 text-lg">欢迎回来，这是今天零工调度的实时监控结果。</p>
      </section>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {stats
          ? [
              { label: '今日待调度', value: stats.pendingDispatch, trend: '+5', color: 'text-indigo-600' },
              { label: '在岗人员', value: stats.activeWorkers, trend: '正常', color: 'text-green-600' },
              { label: '异常考勤', value: stats.abnormalAttendance, trend: '-12%', color: 'text-red-600' },
              { label: '完成率', value: stats.completionRate, trend: '+2%', color: 'text-indigo-600' },
            ].map((item, i) => (
              <div key={i} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-hover hover:shadow-md">
                <p className="text-sm font-medium text-slate-500">{item.label}</p>
                <div className="mt-2 flex items-baseline justify-between">
                  <span className={`text-3xl font-bold ${item.color}`}>{item.value}</span>
                  <span className="text-xs font-semibold text-slate-400">{item.trend}</span>
                </div>
              </div>
            ))
          : Array(4)
              .fill(0)
              .map((_, i) => <div key={i} className="h-32 animate-pulse rounded-2xl bg-slate-100 border border-slate-100" />)}
      </div>

      {adData && <BannerAd creative={adData} />}
      {adData && <StartupAdOverlay open={showAd} creative={adData} countdownSeconds={5} onClose={() => setShowAd(false)} />}
    </AdminLayout>
  );
}
